/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ provider: NonNullable<unknown> }} Conversion_Error_Source_Reconnect_RequiredInputs */

const en_conversion_error_source_reconnect_required = /** @type {(inputs: Conversion_Error_Source_Reconnect_RequiredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Reconnect ${i?.provider} and select the file again.`)
};

const es_conversion_error_source_reconnect_required = /** @type {(inputs: Conversion_Error_Source_Reconnect_RequiredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vuelve a conectar ${i?.provider} y selecciona el archivo de nuevo.`)
};

/**
* | output |
* | --- |
* | "Reconnect {provider} and select the file again." |
*
* @param {Conversion_Error_Source_Reconnect_RequiredInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const conversion_error_source_reconnect_required = /** @type {((inputs: Conversion_Error_Source_Reconnect_RequiredInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Conversion_Error_Source_Reconnect_RequiredInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_conversion_error_source_reconnect_required(inputs)
	return en_conversion_error_source_reconnect_required(inputs)
});